import { render } from "./DataToDo.vue?vue&type=template&id=59251ec3"
import script from "./DataToDo.vue?vue&type=script&lang=js"
export * from "./DataToDo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Pages/DataToDo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "59251ec3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('59251ec3', __exports__)) {
    console.log('reload')
    api.reload('59251ec3', __exports__)
  }
  
  module.hot.accept("./DataToDo.vue?vue&type=template&id=59251ec3", () => {
    console.log('re-render')
    api.rerender('59251ec3', render)
  })

}


export default __exports__